import { React, useState } from 'react';
import { Input, Form, Radio, message } from 'antd';
import { SearchOutlined, DownOutlined } from '@ant-design/icons';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import style from './utils.module.scss';

const CustomButton = ({
  color,
  content,
  size,
  onclick,
  htmlType,
  className,
  disabled,
  children,
}) => {
  const sizeVal = size === 'bg';
  let btnVal;

  switch(color) {
  case 'btnDark':
    btnVal = style.btnDark;
    break;
  case 'btnPrimary':
    btnVal = style.btnPrimary;
    break;
  case 'btnOutline':
    btnVal = style.btnOutline;
    break;
  case 'btnOrange':
    btnVal = style.btnOrange;
    break;
  default:
    btnVal = style.btnLight;
  }

  const attr = {
    className: `${style.button} ${btnVal} ${sizeVal ? style.fontBg : style.fontSm
    } ${className} ${disabled ? style.disBtnBg : ''}`,
    ...(onclick && { onClick: onclick }),
    ...(htmlType && { htmlType }),
  };

  return <button disabled={disabled} {...attr} style={style}>{children}{content}</button>;
};

const CustomSearch = ({ setInput, className, placeholder }) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = () => {
    setInput({
      inputSearch: inputValue,
    });
  };

  return (
    <div className={`${style.inputContainer} ${className ? className : ''}`}>
      <Input className={style.inputStyle} onChange={(e) => handleChange(e)} placeholder={placeholder}/>
      <div className={style.searchIcon} onClick={handleSubmit}>
        <SearchOutlined style={{ 'paddingRight': '.5rem' }} />
      </div>
    </div>
  );
};

const CustomSelect = ({ options, placeholder, setInput }) => {
  const [optionsAreVisible, setOptionsAreVisible] = useState(false);
  const [selectedOpt, setSelectedOpt] = useState(placeholder);

  const toggleOptions = (state) => {
    if (state === 'blur') {
      setOptionsAreVisible(false);
      return;
    }
    setOptionsAreVisible(!optionsAreVisible);
  };

  const handleChange = (value, label) => {
    setInput({ filter: value });
    setSelectedOpt(label);
    toggleOptions();
  };

  return (
    <div
      className={style.selectStyle}
      tabIndex="0"
      onBlur={() => toggleOptions('blur')}
    >
      <div
        className={`${style.defaultOpcContainer} ${optionsAreVisible ? style.defOpcBorder : ''
        }`}
        onClick={toggleOptions}
      >
        <div className={style.defaultOption}>{selectedOpt}</div>
        <div className={style.defOpcArrow}>
          <DownOutlined />
        </div>
      </div>
      {optionsAreVisible && (
        <div className={style.optionsContainer}>
          {options && options.map((o, i) => {
            return (
              <div
                className={style.option}
                key={i}
                onClick={() => handleChange(o.value, o.label)}
              >
                {o.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const FormBuilder = ({ items }) => {
  return (
    <>
      {items && items.map((f, i) => {
        const password = f.inputTag === 'Input.Password';
        const checkbox = f.inputTag === 'Checkbox';
        const input = f.inputTag === 'Input';
        const radio = f.inputTag === 'radio';
        if (input) {
          return (
            <Form.Item {...f.item} key={i}>
              <Input {...f.input} />
            </Form.Item>
          );
        } else if (password) {
          return (
            <Form.Item {...f.item} key={i}>
              <Input.Password {...f.input} />
            </Form.Item>
          );
        } else if (checkbox) {
          return (
            <Form.Item key={i}>
              <Checkbox {...f.input}>{f.item.label}</Checkbox>
            </Form.Item>
          );
        } else if (radio) {
          return (
            <Form.Item {...f.item} key={i}>
              <Radio.Group>
                {f.radio.map((rad, i) => <Radio key={i} value={rad.value}>{rad.label}</Radio>)}
              </Radio.Group>
            </Form.Item>
          );
        }
      })}
    </>
  );
};

const CustomPaginate = (props) => {
  const { setPage,
    page,
    totalPages,
    isSells,
    centered
  } = props;

  const handlePaginate = () => {
    const pages = [];
    if (totalPages < 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      for (let i = page; i < page + 3; i++) {
        if (i <= totalPages) {
          pages.push(i);
        }
      }
      if (pages[0] !== 1) {
        pages.unshift(pages[0] - 1);
      }
    }
    if (pages[0] === 1 && pages[pages.length - 1] === totalPages) {
      return pages.map((currPage, i) => {
        if (page === currPage) {
          return (<div className={`${style.pagItem} ${style.itemActive}`} key={i}>{currPage}</div>);
        } else {
          return (<div onClick={() => setPage(currPage)} className={style.pagItem} key={i}>{currPage}</div>);
        }
      });
    } else if (pages[0] === 1 && pages[pages.length - 1] < totalPages) {
      return (
        <>
          {pages.map((currPage, i) => {
            if (page === currPage) {
              return (<div className={`${style.pagItem} ${style.itemActive}`} key={i}>{currPage}</div>);
            } else {
              return (<div onClick={() => setPage(currPage)} className={style.pagItem} key={i}>{currPage}</div>);
            }
          })}
          <div className={style.pagItemDisabled}>...</div>
          <div className={style.pagItem} onClick={() => setPage(totalPages)}>{totalPages}</div>
        </>
      );
    } else if (pages[0] !== 1 && pages[pages.length - 1] < totalPages) {
      return (
        <>
          <div className={style.pagItem} onClick={() => setPage(1)}>1</div>
          <div className={style.pagItemDisabled}>...</div>
          {pages.map((currPage, i) => {
            if (page === currPage) {
              return (<div className={`${style.pagItem} ${style.itemActive}`} key={i}>{currPage}</div>);
            } else {
              return (<div onClick={() => setPage(currPage)} className={style.pagItem} key={i}>{currPage}</div>);
            }
          })}
          <div className={style.pagItemDisabled}>...</div>
          <div className={style.pagItem} onClick={() => setPage(totalPages)}>{totalPages}</div>
        </>
      );
    } else {
      return (
        <>
          <div className={style.pagItem} onClick={() => setPage(1)}>1</div>
          <div className={style.pagItemDisabled}>...</div>
          {pages.map((currPage, i) => {
            if (page === currPage) {
              return (<div className={`${style.pagItem} ${style.itemActive}`} key={i}>{currPage}</div>);
            } else {
              return (<div onClick={() => setPage(currPage)} className={style.pagItem} key={i}>{currPage}</div>);
            }
          })}
        </>
      );
    }
  };

  const nextOrPrev = (dir) => {
    if ((page === 1 && dir - 1) || (page === totalPages && dir + 1)) {
      return;
    } else {
      setPage(page + dir);
    }
  };

  return (
    <div className={isSells ? style.paginatePositionSells : style.paginatePosition}>
      <div className={style.paginateContainer} style={centered}>
        <div className={style.prevItem} onClick={() => nextOrPrev(-1)}>{'<'}</div>
        {handlePaginate()}
        <div className={style.nexItem} onClick={() => nextOrPrev(+1)}>{'>'}</div>
      </div>
    </div>
  );
};

const LoadingTable = ({_style,color}) => {
  return (
    <div style={_style} className={style.ldsRing}>
      <div style={{borderColor: `${color} transparent transparent transparent`}}></div>
      <div style={{borderColor: `${color} transparent transparent transparent`}}></div>
      <div style={{borderColor: `${color} transparent transparent transparent`}}></div>
      <div style={{borderColor: `${color} transparent transparent transparent`}}></div>
    </div>
  );
};

const MIN_QUANTITY_VALUE = 0;

const customMessage = {
  error: (text, duration) =>
    message.error(
      {
        content: text,
        style: {
          fontSize: '1.24rem',
        },
        duration
      },
    ),
  success: (text, duration) =>
    message.success(
      {
        content: text,
        style: {
          fontSize: '1.24rem',
        },
        duration
      },
    ),
  info: (text, duration, size) =>
    message.info(
      {
        content: text,
        style: {
          fontSize: size ? size : '1.24rem',
        },
        duration
      },
    ),
};

export { CustomButton, CustomSearch, CustomSelect, FormBuilder, CustomPaginate, LoadingTable, MIN_QUANTITY_VALUE, customMessage as message};
